(() => {
  const expire = () => {
    document.querySelectorAll('[data-fos-editorial-expiry]').forEach(tile => {
      const end = Number(tile.dataset.fosEditorialExpiry);
      if (end > 0 && Date.now() >= end * 1000) tile.remove();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', expire);
  else expire();
  document.addEventListener('shopify:section:load', expire);
  document.addEventListener('visibilitychange', expire);
  setInterval(expire, 60000);
})();
